import '../pages/assets/dist/css/bootstrap.min.css';

function BotonIngreso(){
    return(
        <a id="botonIngresoMain" class="btn btn-primary" href="/webcenter/portal/FarmalinkPortal" role="button">INGRESAR</a>
    );
}

export default BotonIngreso;